import { ProgressbarAPI } from '../../../api/datamanager/ProgressbarAPI';

export class ProgressbarCommand {
    get(oldData, successCallback, errorCallback) {
        const apiResult = ProgressbarAPI.get(oldData);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((error) => {
            if (undefined !== errorCallback) {
                errorCallback(error.message);
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/datamanager/commands/ProgressbarCommand.js